import React, { Fragment, useState, useEffect } from 'react';
import { Col, Row, Button } from 'reactstrap';
import { DatePicker, KeyboardDatePicker, MuiPickersUtilsProvider, TimePicker } from "@material-ui/pickers";
import { createMuiTheme, ThemeProvider } from "@material-ui/core/styles";
import MomentUtils from '@date-io/moment';
import TextField from '@material-ui/core/TextField';
import moment from 'moment';
import IconButton from '@material-ui/core/IconButton';
import Modal from '@material-ui/core/Modal';
import CloseIcon from '@material-ui/icons/Close';
import incapacityPDF from './incapacityPDF';
import ModalUI from '../../../../../shared/components/Modal';
import DataReactTableIncapacity from './DataReactTableIncapacity';
import Spinner from 'react-bootstrap/Spinner';


const defaultMaterialTheme = createMuiTheme({
    palette: {
        primary: {
            main: '#3EA3FC',
            contrastText: "#fff"
        },

    },
});
const no_op = () => { };
const MedicalIncapacity = ({ data, profesional, infoAdmission, thirdInfo, diagnostic, openModal = false, setOpenModal = no_op, disabledForm = false }) => {
    const [dates, setDates] = useState({ startDate: null, endDate: null });
    const [daysIncapacity, setDaysIncapacity] = useState(null);
    const [observationIncap, setObservationIncap] = useState('');
    const [incapacityByThisAdmision, setIncapacityByThisAdmision] = useState(null);
    const [incapacitiesByPatient, setIncapacitiesByPatient] = useState(null);
    const [isOnUpdate, setIsOnUpdate] = useState(false);
    const [printPDFIncap, setPrintPDFIncap] = useState(false);
    const [errors, setErrors] = useState({});
    const [loadTableIncapacity, setLoadTableIncapacity] = useState(false);

    const [openAlert, setOpenAlert] = useState(false);
    const [modalAlert, setModalAlert] = useState({ message: '', color: '', title: '' });

    const currentUser = JSON.parse(sessionStorage.getItem('usuario'));
    const { id_admision, id_historia } = data;


    useEffect(() => {
        loadIncapacityByIdHistoryPatient();
        loadIncapacityByThisAdmission();
    }, [])

    useEffect(() => {
        if (!!incapacityByThisAdmision) {
            if (!!incapacityByThisAdmision.length) {
                setObservationIncap(incapacityByThisAdmision[0].observaciones);
                setDaysIncapacity(incapacityByThisAdmision[0].dias_incapacidad);
                setDates({ ...dates, startDate: incapacityByThisAdmision[0].fecha_incial, endDate: incapacityByThisAdmision[0].fecha_final })
            }
        }
    }, [incapacityByThisAdmision])


    const handlerNumberDays = (daysNumberSelected) => {
        if (dates.startDate !== null && dates.endDate !== null) {
            let startDate = moment(dates.startDate);
            let endDate = moment(startDate).add(parseInt(daysNumberSelected) - 1, 'days');
            setDaysIncapacity(daysNumberSelected);
            setDates({ ...dates, startDate, endDate })
        } else if (dates.startDate === null && dates.endDate !== null) {
            let endDate = moment(dates.endDate)
            let startDate = moment(endDate).subtract(parseInt(daysNumberSelected) + 1, 'days');
            setDaysIncapacity(daysNumberSelected);
            setDates({ ...dates, startDate, endDate })
        } else if (dates.startDate !== null && dates.endDate === null) {
            let startDate = moment(dates.startDate)
            let endDate = moment(startDate).add(parseInt(daysNumberSelected) - 1, 'days');
            setDaysIncapacity(daysNumberSelected);
            setDates({ ...dates, startDate, endDate })
        } else {
            let startDate = moment(new Date());
            let endDate = moment(startDate).add(parseInt(daysNumberSelected) - 1, 'days');
            setDaysIncapacity(daysNumberSelected);
            setDates({ ...dates, startDate, endDate })
        }
    }

    const handlerStartDate = (startDateFromFrom) => {
        let startDate = moment(startDateFromFrom);
        if (!!dates.endDate) {
            let endDate = moment(dates.endDate);
            let totalDays = endDate.diff(startDate, 'days');
            setDaysIncapacity(totalDays + 1);
            setDates({ ...dates, startDate, endDate })
        } else {
            setDates({ ...dates, startDate })
        }
    }

    const handlerEndDate = (endDateFromFrom) => {
        let endDate = moment(endDateFromFrom);
        if (!!dates.startDate) {
            let startDate = moment(dates.startDate);
            let totalDays = endDate.diff(startDate, 'days');
            setDaysIncapacity(totalDays + 1);
            setDates({ ...dates, startDate, endDate })
        } else {
            setDates({ ...dates, endDate })
        }
    }

    const loadIncapacityByThisAdmission = async () => {
        await fetch(process.env.REACT_APP_PUBLIC_URL + 'incapacidades-clinicas/consultar-por-admision?id_admision=' + id_admision, {
            method: 'GET',
            headers: {
                'Content-Type': 'application/json',
                'authorization': 'Bearer ' + sessionStorage.getItem('token'),
            },
        })
            .then(response => {
                return response.json();
            })
            .then(data => {
                console.log("cargar incapacidad", data);
                if (!!data) {
                    if (!!data.length) {
                        setIncapacityByThisAdmision(data);
                        setIsOnUpdate(true);
                    } else {
                        setIncapacityByThisAdmision(null);
                    }
                } else {
                    setIncapacityByThisAdmision(null);
                }
            })
            .catch((error) => {
                console.error('Error:', error);
            });
    }

    const loadIncapacityByIdHistoryPatient = async () => {
        setLoadTableIncapacity(true);
        await fetch(process.env.REACT_APP_PUBLIC_URL + 'incapacidades-clinicas/consultar?id_historia=' + id_historia, {
            method: 'GET',
            headers: {
                'Content-Type': 'application/json',
                'authorization': 'Bearer ' + sessionStorage.getItem('token'),
            },
        })
            .then(response => {
                return response.json();
            })
            .then(data => {
                console.log("cargar incapacidad History", data);
                if (!!data) {
                    if (!!data.length) {
                        let dataToFilter = data.filter(incap => incap.id_admision !== parseInt(id_admision));
                        setIncapacitiesByPatient(dataToFilter);
                        setLoadTableIncapacity(false);
                    } else {
                        setIncapacitiesByPatient(null);
                        setLoadTableIncapacity(false);
                    }
                } else {
                    setIncapacitiesByPatient(null);
                    setLoadTableIncapacity(false);
                }
            })
            .catch((error) => {
                console.error('Error:', error);
            });
    }


    const validateForm = () => {
        const errors = {};
        if (!dates.startDate) {
            errors.startDate = "Seleccione una fecha de inicio";
        }
        if (!dates.endDate) {
            errors.endDate = "Seleccione una fecha final";
        }
        if (!daysIncapacity) {
            errors.daysNumber = "Digite el número de días";
        }
        setErrors(errors)
    }

    const saveIncapacity = async () => {
        validateForm();
        let diagnosticsByThisAdmission = diagnostic.addedDiagnostics
        var data = {
            id_historia: id_historia,
            id_admision: id_admision,
            observaciones: observationIncap,
            fecha_incial: moment(dates.startDate),
            fecha_final: moment(dates.endDate),
            dias_incapacidad: daysIncapacity,
            id_usuario: currentUser?.id_usuario
        }
        if (!!diagnosticsByThisAdmission.length) {
            if (JSON.stringify(errors) === '{}') {
                await fetch(process.env.REACT_APP_PUBLIC_URL + 'incapacidades-clinicas/create', {
                    method: 'POST',
                    headers: {
                        'Content-Type': 'application/json',
                        'authorization': 'Bearer ' + sessionStorage.getItem('token'),
                    },
                    body: JSON.stringify(data)
                }).then(response => {
                    if (response.status != 500 && response.status != 403) {
                        console.log("Incapacidad registrada Correctamente");
                        loadIncapacityByThisAdmission();
                        setOpenAlert(true);
                        setModalAlert({
                            message: "Guardado con exito",
                            color: 'success',
                            title: "Exitoso!"
                        });
                    }
                    else {
                        throw new Error("Ha ocurrido un error en el servidor");
                    }
                })
                    .catch((error) => {
                        console.error('Error:', error);
                    });
            }
        } else {
            alert('Digilencie primero un diagnostico para crear una incapacidad')
        }
    }

    const updateIncapacity = () => {
        var data = {
            id_hist_incapacidad: parseInt(incapacityByThisAdmision[0].id_hist_incapacidad),
            observaciones: observationIncap,
            fecha_incial: moment(dates.startDate),
            fecha_final: moment(dates.endDate),
            dias_incapacidad: daysIncapacity,
            id_usuario: currentUser?.id_usuario

        }
        fetch(process.env.REACT_APP_PUBLIC_URL + 'incapacidades-clinicas/update', {
            method: 'PUT',
            headers: {
                'Content-Type': 'application/json',
                'authorization': 'Bearer ' + sessionStorage.getItem('token'),
            },
            body: JSON.stringify(data)
        })
            .then(response => {
                return response.text();
            })
            .then(response => {
                if (response.status != 500 && response.status != 403) {
                    console.log("Nota Clinica actualizada Correctamente");
                    //this.fetchListNotes();
                    loadIncapacityByThisAdmission();
                    setOpenAlert(true);
                    setModalAlert({
                        message: "Actualizado con exito",
                        color: 'success',
                        title: "Exitoso!"
                    });
                }
                else {
                    throw new Error("Ha ocurrido un error en el servidor");
                }
            })
            .catch((error) => {
                console.error('Error:', error);
            });
    }

    const loadDataCitaToCreateReceipt = (id_cita) => {
        var data = { id_cita: id_cita };
        return new Promise((resolve, reject) => {
            fetch(process.env.REACT_APP_PUBLIC_URL + 'agenda/consultarpaciente', {
                method: 'POST',
                headers: {
                    'Content-Type': 'application/json',
                    'authorization': 'Bearer ' + sessionStorage.getItem('token'),
                },
                body: JSON.stringify(data)
            })
                .then(response => {
                    return response.json();
                })
                .then(data => {
                    if (data.existe) {
                        resolve(data.contenido);
                    }
                })
                .catch((error) => {
                    resolve(error)
                    console.error('Error:', error);
                });
        })
    }

    const printPDFIncapacity = async () => {
        const profile = JSON.parse(sessionStorage.getItem('clinica'));
        const urlLogo = sessionStorage.getItem('logoURL');
        /* let dataCitaInfoSentToCreateReceipt = await loadDataCitaToCreateReceipt(parseInt(data.id_cita));
        let idPlan = !!dataCitaInfoSentToCreateReceipt ? dataCitaInfoSentToCreateReceipt.idPlan : null; */
        let diagnosticsByThisAdmission = diagnostic.addedDiagnostics

        if (!!diagnosticsByThisAdmission.length) {
            const dataToSend = {
                fecha: moment(data.fecha_ingreso_completa_admision).format('DD-MM-YYYY'),
                hora: moment(data.fecha_ingreso_completa_admision).format('HH:mm'),
                typeOfDocument: data.tip_documento,
                documentNumber: data.num_documento,
                birthday: data.birthday,
                names: data.fullname,
                direccion: data.adress.direccion,
                celular: data.telephone,
                professional: profesional,
                infoAdmission: infoAdmission,
                profile: profile,
                urlLogo: urlLogo,
                thirdName: thirdInfo?.nombre,
                diagnostics: diagnostic,
                observations: observationIncap,
                startDateIncapacity: dates.startDate,
                endDateIncapacity: dates.endDate,
                infoIncapacityCurrentAdmision: incapacityByThisAdmision
            }
            setPrintPDFIncap(true);
            incapacityPDF(dataToSend);
        } else {
            alert('No se ha seleccionado ningún diagnostico para esta admisión')
        }

    }

    const reactTableDataIncapacity = {
        tableHeaderData: [{
            Header: 'No.',
            accessor: 'id_hist_incapacidad',
            disableGlobalFilter: true,
            width: 65
        },
        {
            Header: 'ADMISION No.',
            accessor: 'id_admision',
        },
        {
            Header: 'DÍAS DE INCAPACIDAD',
            accessor: 'dias_incapacidad',
        },
        {
            Header: 'FECHA INCIO',
            accessor: 'fecha_incial',
            Cell: row => (<p>{moment(row.value).format("YYYY-MM-DD")}</p>)
        },
        {
            Header: 'FECHA FINAL',
            accessor: 'fecha_final',
            Cell: row => (<p>{moment(row.value).format("YYYY-MM-DD")}</p>)
        },
        ],
        tableRowsData: !!incapacitiesByPatient ? incapacitiesByPatient : []
    };

    const LoadInfo = () => {
        return (<DataReactTableIncapacity
            reactTableData={reactTableDataIncapacity}
        />)
    }

    return (
        <Fragment>
            <Modal
                open={openModal}
                onClose={() => {
                    setOpenModal(false);
                }}
                aria-labelledby="simple-modal-title"
                aria-describedby="simple-modal-description"
                style={{ zIndex: 1000 }}>
                <div className="paperAppointment-flex aditional-modal-paper">
                    <Col md={12} sm={12}>
                        <div className={"container-wraper-hc"}>
                            <div className="title-clinic-history">
                                <h4>Incapacidad Médica</h4>
                            </div>

                            <Row>
                                <Col md={4}>
                                    <MuiPickersUtilsProvider utils={MomentUtils}>
                                        <ThemeProvider theme={defaultMaterialTheme}>
                                            <DatePicker
                                                className="medical-material-form__field"
                                                minDate={new Date()}
                                                maxDate={!!dates.endDate ? dates.endDate : new Date()}
                                                InputLabelProps={{
                                                    style: { color: '#646777' }, shrink: true
                                                }}
                                                variant="inline"
                                                label="Fecha Inicio"
                                                value={dates.startDate}
                                                onChange={(date) => {
                                                    // setDates({ ...dates, startDate: new Date(date) });
                                                    //setDaysIncapacityAccordingToDates(null, new Date(date), dates.endDate)
                                                    handlerStartDate(new Date(date));
                                                }}
                                                format="DD/MM/yyyy"
                                                animateYearScrolling
                                                error={errors.hasOwnProperty("startDate") ? errors.startDate !== "" : false}
                                                helperText={errors.startDate}
                                                autoOk={true}
                                            />
                                        </ThemeProvider>

                                    </MuiPickersUtilsProvider>
                                </Col>
                                <Col md={4}>
                                    <MuiPickersUtilsProvider utils={MomentUtils}>
                                        <ThemeProvider theme={defaultMaterialTheme}>
                                            <DatePicker
                                                className="medical-material-form__field"
                                                minDate={!!dates.startDate ? dates.startDate : new Date()}
                                                InputLabelProps={{
                                                    style: { color: '#646777' }, shrink: true
                                                }}
                                                variant="inline"
                                                label="Fecha final"
                                                value={dates.endDate}
                                                onChange={(date) => {
                                                    //setDates({ ...dates, endDate: new Date(date) });
                                                    //setDaysIncapacityAccordingToDates(null, dates.startDate, new Date(date));
                                                    handlerEndDate(new Date(date));
                                                }}
                                                format="DD/MM/yyyy"
                                                animateYearScrolling
                                                error={errors.hasOwnProperty("endDate") ? errors.endDate !== "" : false}
                                                helperText={errors.endDate}
                                                autoOk={true}
                                            />
                                        </ThemeProvider>
                                    </MuiPickersUtilsProvider>
                                </Col>
                                <Col md={4}>
                                    <TextField
                                        label="Dias de Incapacidad"
                                        /* disabled={this.props.stateClinicHistory} */
                                        value={daysIncapacity}
                                        style={{ marginLeft: '0.25em' }}
                                        type='number'
                                        onChange={(e) => {
                                            //setDaysIncapacity(e.target.value)
                                            //setDaysIncapacityAccordingToDates(e.target.value);
                                            //setDaysIncapacityAccordingToDates(e.target.value, dates.startDate, dates.endDate);
                                            handlerNumberDays(e.target.value);
                                        }}
                                        className="medical-material-form__field"
                                        InputLabelProps={{
                                            style: { color: '#646777' }, shrink: true,
                                        }}
                                        error={errors.hasOwnProperty("daysNumber") ? errors.daysNumber !== "" : false}
                                        helperText={errors.daysNumber}
                                    />
                                </Col>
                            </Row>
                            <Row>
                                <Col md={12}>
                                    <TextField
                                        label="Observaciones"
                                        /* disabled={this.props.stateClinicHistory} */
                                        value={observationIncap}
                                        multiline
                                        rows={1}
                                        style={{ marginLeft: '0.25em' }}
                                        onChange={(e) => {
                                            setObservationIncap(e.target.value)
                                        }}
                                        className="medical-material-form__field"
                                        InputLabelProps={{
                                            style: { color: '#646777' }, shrink: true,
                                        }}
                                    />
                                </Col>
                            </Row>
                            <Row>
                                <div className='flex-row' style={{ justifyContent: 'flex-end', margin: '1em 0em' }}>
                                    {/* <Button
                                        variant="contained"
                                        color="primary"
                                        size="sm"
                                        onClick={() => {
                                            setOpenModal();
                                        }}
                                    >
                                        Cerrar
                                    </Button> */}
                                    {!!incapacityByThisAdmision ?
                                        <Button
                                            variant="contained"
                                            color="primary"
                                            size='sm'
                                            /* disabled={this.state.costumer_data !== null && this.state.costumer_data !== undefined ? false : true} */
                                            onClick={() => {
                                                printPDFIncapacity();
                                            }}
                                        >
                                            Imprimir
                                        </Button>
                                        : null}
                                    <Button
                                        variant="contained"
                                        color="primary"
                                        size='sm'
                                        /* disabled={this.state.costumer_data !== null && this.state.costumer_data !== undefined ? false : true} */
                                        onClick={() => {
                                            if (isOnUpdate) {
                                                updateIncapacity();
                                            } else {
                                                saveIncapacity();
                                            }
                                        }}
                                    >
                                        {isOnUpdate ? "Actualizar" : "Guardar"}
                                    </Button>

                                </div>
                            </Row>
                            {!!incapacitiesByPatient ?
                                !!incapacitiesByPatient.length ?
                                    <div className="title-clinic-history">
                                        <h4>Incapacidades Anteriores</h4>
                                    </div>
                                    : null
                                : null
                            }
                            <Row>
                                {
                                    loadTableIncapacity ?
                                        <div className="text-center">
                                            <Spinner animation="border" style={{ color: '#4ce1b6' }} />
                                        </div>
                                        : !!incapacitiesByPatient ?
                                            !!incapacitiesByPatient.length ?
                                                <LoadInfo />
                                                : null
                                            : null
                                }
                            </Row>
                        </div>
                    </Col >
                </div>
            </Modal>
            {printPDFIncap ?
                <Modal
                    open={printPDFIncap}
                    aria-labelledby="simple-modal-title"
                    aria-describedby="simple-modal-description"
                    style={{ zIndex: 1000 }}
                >
                    <div className="paperAppointment-flex" style={{ width: '80%', margin: 10, height: '80%' }}>
                        <IconButton style={{ float: 'right' }} onClick={() => {
                            setPrintPDFIncap(false);
                        }}>
                            <CloseIcon />
                        </IconButton>
                        <iframe id="pdfV" width="100%" height="90%" title="pdf-report" >
                        </iframe>
                    </div>
                </Modal>
                : null}

            {openAlert ?
                <ModalUI
                    color={modalAlert.color}
                    title={modalAlert.title}
                    message={modalAlert.message}
                    modal={openAlert}
                    toggle={() => { setOpenAlert(!openAlert) }}
                    onOk={() => { setOpenAlert(!openAlert) }}
                /> : null}
        </Fragment >
    )
}
export default MedicalIncapacity